export default __webpack_public_path__ + "static/media/short_info.43591bf1.csv";